<template>
 <div class=" sa-row sa-h100">
    <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4" v-if="scheduledata">
      <div class="sa-schd-week">
        <a class="sa-sprite sa-week" @click="currentday='sun'; scrollDown()" :class="{ 'active': currentday === 'sun'}">
              <div class="sa-week-info">
                Sunday
                <span class="sa-h-xs" v-if="gettypes(scheduledata.slots['sun']).length>=1">{{gettypes(scheduledata.slots['sun'])}}</span>
                <span class="sa-h-xs" v-else>No schedule</span>
              </div>
          </a>
          <a class="sa-sprite sa-week" @click="currentday='mon'; scrollDown()" :class="{ 'active': currentday === 'mon'}">
              <div class="sa-week-info">
                Monday
                <span class="sa-h-xs" v-if="gettypes(scheduledata.slots['mon']).length>=1">{{gettypes(scheduledata.slots['mon'])}}</span>
                <span class="sa-h-xs" v-else>No schedule</span>
              </div>
          </a>
          <a class="sa-sprite sa-week" @click="currentday='tue'; scrollDown()" :class="{ 'active': currentday === 'tue'}">
              <div class="sa-week-info">
                Tuesday
                <span class="sa-h-xs" v-if="gettypes(scheduledata.slots['tue']).length>=1">{{gettypes(scheduledata.slots['tue'])}}</span>
                <span class="sa-h-xs" v-else>No schedule</span>
              </div>
          </a>
          <a class="sa-sprite sa-week" @click="currentday='wed'" :class="{ 'active': currentday === 'wed'}">
              <div class="sa-week-info">
                Wednesday
                <span class="sa-h-xs" v-if="gettypes(scheduledata.slots['wed']).length>=1">{{gettypes(scheduledata.slots['wed'])}}</span>
                <span class="sa-h-xs" v-else>No schedule</span>
              </div>
          </a>
          <a class="sa-sprite sa-week" @click="currentday='thu'; scrollDown()" :class="{ 'active': currentday === 'thu'}">
              <div class="sa-week-info">
                Thursday
                <span class="sa-h-xs" v-if="gettypes(scheduledata.slots['thu']).length>=1">{{gettypes(scheduledata.slots['thu'])}}</span>
                <span class="sa-h-xs" v-else>No schedule</span>
              </div>
          </a>
          <a class="sa-sprite sa-week" @click="currentday='fri'; scrollDown()" :class="{ 'active': currentday === 'fri'}">
              <div class="sa-week-info">
                Friday
                <span class="sa-h-xs" v-if="gettypes(scheduledata.slots['fri']).length>=1">{{gettypes(scheduledata.slots['fri'])}}</span>
                <span class="sa-h-xs" v-else>No schedule</span>
              </div>
          </a>
          <a class="sa-sprite sa-week" @click="currentday='sat'" :class="{ 'active': currentday === 'sat'}">
              <div class="sa-week-info">
                Saturday
                <span class="sa-h-xs" v-if="gettypes(scheduledata.slots['sat']).length>=1">{{gettypes(scheduledata.slots['sat'])}}</span>
                <span class="sa-h-xs" v-else>No schedule</span>
              </div>
          </a>
      </div>
    </div> 
    <schedule-time id="container" v-if="scheduledata" :scheduletime="scheduledataprop" :currentday="currentday" :slService='slService' :multi_slot='multi_slot'/>
</div>
</template>
<script>
import  ScheduleTimeVue from '../../components/schedule/ScheduleTime.vue'
  export default {
    data() {
      return {
        weekDays: [
          { info: "Sunday"},
          { info: "Monday"},
          { info: "Tuesday"},
          { info: "Wednesday"},
          { info: "Thursday"},
          { info: "Friday"},
          { info: "Saturday"}
        ],
        currentday:'sun'
      };
    },
    methods: {
      scrollDown: function(){
        var container = this.$el.querySelector("#container");
        container.scrollTop = container.scrollHeight;
      },
      gettypes:function(val){
      /* let result = val.find(obj => {
        return obj.pid === this.pname;
      }); */
      let video = false;
      let home = false;
      val.forEach(function (arrayItem) {
          if(arrayItem.stid==='ST0'){
              home=true
          }
          if(arrayItem.stid==='ST1'){
              video=true
          }
      });
      if(home&&video){
        return "Home Visit & Video Consultation";
      }
      else if(home&&!video){
        return "Home Visit"
      }
      else if(!home&&video){
        return "Video Consultation"
      }
      else{
        return ''
      }
      },
      weekDaysClick(value) {
        this.$emit('change', value);
      },
    },
    props:['scheduledata','slService','multi_slot'],
    components:{
      'schedule-time':ScheduleTimeVue
    },
    computed:{
      scheduledataprop:function(){
        return this.scheduledata
      }
    }
  
  };
</script>
